import { ICombinedFeedConfiguration } from "./index";

export const COMBINED_FEED_CONFIGURATIONS = {
  control: {
    title: "Recommended for You",
    showExpandable: true,
    maxPerRow: 6,
    shuffleAlgorithm: "balanced" as const,
    totalClipLimit: 15,
    enableReasonBadges: true,
    feedConfig: [
      {
        source: "followingClips" as const,
        reason: "Following",
        maxItems: 4,
        priority: 1,
      },
      {
        source: "playedWithClips" as const,
        reason: "Played With",
        maxItems: 3,
        priority: 2,
      },
      {
        source: "proPlayerClips" as const,
        reason: "PRO Player",
        maxItems: 5,
        priority: 3,
      },
      {
        source: "recommendedClips" as const,
        reason: "Suggested for you",
        maxItems: 3,
        priority: 4,
      },
    ],
  } as ICombinedFeedConfiguration,

  proPlayerFocused: {
    title: "Pro Player Highlights",
    showExpandable: true,
    maxPerRow: 6,
    shuffleAlgorithm: "priority" as const,
    totalClipLimit: 18,
    enableReasonBadges: true,
    feedConfig: [
      {
        source: "proPlayerClips" as const,
        reason: "PRO Player",
        maxItems: 8,
        priority: 1,
      },
      {
        source: "followingClips" as const,
        reason: "Following",
        maxItems: 3,
        priority: 2,
      },
      {
        source: "playedWithClips" as const,
        reason: "Played With",
        maxItems: 2,
        priority: 3,
      },
      {
        source: "recommendedClips" as const,
        reason: "Suggested for you",
        maxItems: 2,
        priority: 4,
      },
    ],
  } as ICombinedFeedConfiguration,

  socialFocused: {
    title: "From Your Network",
    showExpandable: true,
    maxPerRow: 5,
    shuffleAlgorithm: "random" as const,
    totalClipLimit: 12,
    enableReasonBadges: true,
    feedConfig: [
      {
        source: "followingClips" as const,
        reason: "Following",
        maxItems: 6,
        priority: 1,
      },
      {
        source: "playedWithClips" as const,
        reason: "Played With",
        maxItems: 4,
        priority: 1,
      },
      {
        source: "proPlayerClips" as const,
        reason: "PRO Player",
        maxItems: 2,
        priority: 2,
      },
      {
        source: "recommendedClips" as const,
        reason: "Suggested for you",
        maxItems: 2,
        priority: 3,
      },
    ],
  } as ICombinedFeedConfiguration,

  compact: {
    title: "More Clips",
    showExpandable: false,
    maxPerRow: 8,
    shuffleAlgorithm: "balanced" as const,
    totalClipLimit: 8,
    enableReasonBadges: false,
    feedConfig: [
      {
        source: "followingClips" as const,
        reason: "Following",
        maxItems: 2,
        priority: 1,
      },
      {
        source: "playedWithClips" as const,
        reason: "Played With",
        maxItems: 2,
        priority: 2,
      },
      {
        source: "proPlayerClips" as const,
        reason: "PRO Player",
        maxItems: 2,
        priority: 3,
      },
      {
        source: "recommendedClips" as const,
        reason: "Suggested for you",
        maxItems: 2,
        priority: 4,
      },
    ],
  } as ICombinedFeedConfiguration,

  gamingFocused: {
    title: "Featured Gaming Clips",
    showExpandable: true,
    maxPerRow: 6,
    shuffleAlgorithm: "priority" as const,
    totalClipLimit: 20,
    enableReasonBadges: true,
    feedConfig: [
      {
        source: "playedWithClips" as const,
        reason: "Played With",
        maxItems: 7,
        priority: 1,
      },
      {
        source: "proPlayerClips" as const,
        reason: "PRO Player",
        maxItems: 6,
        priority: 2,
      },
      {
        source: "followingClips" as const,
        reason: "Following",
        maxItems: 4,
        priority: 3,
      },
      {
        source: "recommendedClips" as const,
        reason: "Suggested for you",
        maxItems: 3,
        priority: 4,
      },
    ],
  } as ICombinedFeedConfiguration,

  custom4Plus3Plus3: {
    title: "For You",
    showExpandable: true,
    maxPerRow: 5,
    shuffleAlgorithm: "interleavedByPriority" as const,
    totalClipLimit: 10,
    enableReasonBadges: true,
    feedConfig: [
      {
        source: "followingClips" as const,
        reason: "Following",
        maxItems: 3,
        priority: 1,
      },
      {
        source: "playedWithClips" as const,
        reason: "Played With",
        maxItems: 3,
        priority: 2,
      },
      {
        source: "proPlayerClips" as const,
        reason: "PRO Player",
        maxItems: 3,
        priority: 3,
      },
      {
        source: "recommendedClips" as const,
        reason: "Suggested for you",
        maxItems: 1,
        priority: 4,
      },
    ],
  } as ICombinedFeedConfiguration,
};
